module.exports = __webpack_public_path__ + "img/item2.63543801.png";